import { HashRouter, Route, Routes } from 'react-router';
import myEnvironmentRoutes from '~/routes/myEnvironment';
import Login from './MyEnvironment/Login';
import Reservations from './MyEnvironment/Reservations';
import Reservation from './MyEnvironment/Reservation';

export default function MyEnvironment() {
  return (
    <HashRouter>
      <Routes>
        <Route
          index
          path={myEnvironmentRoutes.LOGIN}
          element={<Login />}
        />
        <Route
          path={myEnvironmentRoutes.RESERVATIONS}
          element={<Reservations />}
        />
        <Route
          path={myEnvironmentRoutes.RESERVATION}
          element={<Reservation />}
        />
      </Routes>
    </HashRouter>
  );
}
